import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"

import IssueList from "QuorumGrassroots/widgets/IssueList/components/index"

import { issueListSelector } from "QuorumGrassroots/widgets/IssueList/selectors"

export default withNamespaces()(connect(issueListSelector, null)(IssueList))
